import React from 'react';
import { Play, Sparkles } from 'lucide-react';

const VideoSection = () => {
  return (
    <section id="video" className="py-20 bg-gradient-to-b from-white via-purple-50 to-pink-50 relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute top-10 left-10 text-5xl opacity-20 animate-float">🎬</div>
      <div className="absolute bottom-10 right-10 text-5xl opacity-20 animate-float" style={{ animationDelay: '1s' }}>🎥</div>
      <div className="absolute top-1/2 left-5 text-3xl opacity-20 animate-float" style={{ animationDelay: '0.5s' }}>✨</div>
      <div className="absolute top-20 right-20 text-3xl opacity-20 animate-float" style={{ animationDelay: '1.5s' }}>🌟</div>

      <div className="max-w-5xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white shadow-lg mb-4">
            <Play className="w-5 h-5 text-purple-600" />
            <span className="font-bold text-purple-600">Watch the Action!</span>
            <Sparkles className="w-5 h-5 text-yellow-500" />
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-800 mb-4">
            DevOps{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 via-pink-500 to-orange-400">
              Adventure
            </span>{' '}
            in Action
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            Watch Captain DevSecOps defend clusters and deploy with zero downtime! 🚀
          </p>
        </div>

        {/* Video Container */}
        <div className="relative">
          {/* Glow effect behind video */}
          <div className="absolute -inset-4 bg-gradient-to-r from-purple-400 via-pink-400 to-orange-400 rounded-3xl blur-2xl opacity-30 animate-pulse" />
          
          {/* Video wrapper */}
          <div className="relative bg-white rounded-3xl p-3 shadow-2xl border-4 border-purple-200 overflow-hidden">
            {/* Decorative corner badges */}
            <div className="absolute -top-2 -left-2 w-12 h-12 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-xl flex items-center justify-center shadow-lg z-10 rotate-[-12deg]">
              <span className="text-xl">🎬</span>
            </div>
            <div className="absolute -top-2 -right-2 w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl flex items-center justify-center shadow-lg z-10 rotate-[12deg]">
              <span className="text-xl">⚡</span>
            </div>

            {/* Video element */}
            <video
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              className="w-full h-auto rounded-2xl"
              data-testid="adventure-video"
            >
              <source 
                src="https://customer-assets.emergentagent.com/job_868ee71b-fee2-43d8-a69c-eb4f0327be23/artifacts/3sj2fj6p_Cartoon_DevOps_Video_Generation.mp4" 
                type="video/mp4" 
              />
              Your browser does not support the video tag.
            </video>

            {/* Bottom label */}
            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 bg-white/90 backdrop-blur px-4 py-2 rounded-full shadow-lg border-2 border-purple-200">
              <span className="text-sm font-bold text-purple-600 flex items-center gap-2">
                <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
                Live Mission Feed
              </span>
            </div>
          </div>
        </div>

        {/* Fun stats below video */}
        <div className="flex flex-wrap justify-center gap-6 mt-10">
          <div className="bg-white rounded-2xl px-6 py-3 shadow-lg border-2 border-blue-200 flex items-center gap-3">
            <span className="text-2xl">🚢</span>
            <div>
              <p className="text-xs text-gray-500 font-medium">Clusters Defended</p>
              <p className="text-lg font-black text-blue-600">100+</p>
            </div>
          </div>
          <div className="bg-white rounded-2xl px-6 py-3 shadow-lg border-2 border-green-200 flex items-center gap-3">
            <span className="text-2xl">🛡️</span>
            <div>
              <p className="text-xs text-gray-500 font-medium">Threats Blocked</p>
              <p className="text-lg font-black text-green-600">10,000+</p>
            </div>
          </div>
          <div className="bg-white rounded-2xl px-6 py-3 shadow-lg border-2 border-purple-200 flex items-center gap-3">
            <span className="text-2xl">🚀</span>
            <div>
              <p className="text-xs text-gray-500 font-medium">Deployments</p>
              <p className="text-lg font-black text-purple-600">∞</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
